import { render, staticRenderFns } from "./nearAccidentDetail.vue?vue&type=template&id=925b9b84"
import script from "./nearAccidentDetail.vue?vue&type=script&lang=js"
export * from "./nearAccidentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('925b9b84')) {
      api.createRecord('925b9b84', component.options)
    } else {
      api.reload('925b9b84', component.options)
    }
    module.hot.accept("./nearAccidentDetail.vue?vue&type=template&id=925b9b84", function () {
      api.rerender('925b9b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/near/nearAccidentDetail.vue"
export default component.exports